import Component from './assistant-card-exterior'

export default Component
